// extracted by mini-css-extract-plugin
module.exports = {"importTaskHeader":"SpecialPriceUpdate_importTaskHeader__2ShJ9","importTaskInfo":"SpecialPriceUpdate_importTaskInfo__3Uegj"};